/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * * `low` - Nízká * `reduced` - Snížená * `adequate` - Přiměřená * `very_good` - Velmi dobrá
 */
export type AuditoryPerceptionLevelEnum = 'low' | 'reduced' | 'adequate' | 'very_good';

export const AuditoryPerceptionLevelEnum = {
    Low: 'low' as AuditoryPerceptionLevelEnum,
    Reduced: 'reduced' as AuditoryPerceptionLevelEnum,
    Adequate: 'adequate' as AuditoryPerceptionLevelEnum,
    VeryGood: 'very_good' as AuditoryPerceptionLevelEnum
};